import request from '@/config/axios'

export interface O2oDashboardSummaryVO {
  todayGmv?: number
  todayOrderCount?: number
  processingOrderCount?: number
  pendingDispatchCount?: number
  pendingAfterSaleCount?: number
  pendingDisputeCount?: number
  activeProviderCount?: number
  todayRefundRate?: number
  todayDisputeRate?: number
}

export interface O2oDashboardTrendVO {
  dates?: string[]
  gmv?: number[]
  orderCount?: number[]
}

/** O2O 数据看板 — /admin-api/o2o/dashboard/* */
export const O2oDashboardApi = {
  getSummary: async () => {
    return await request.get<O2oDashboardSummaryVO>({ url: '/o2o/dashboard/summary' })
  },
  getTrend: async () => {
    return await request.get<O2oDashboardTrendVO>({ url: '/o2o/dashboard/trend' })
  },
  getAvailabilityStats: async () => request.get<any>({ url: '/o2o/ops/availability-stats' })
}
